/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * サービス種別
 * @export
 * @enum {number}
 */
export enum ServiceCategoryEnum {
    /** 海外連携サービス */
    OVERSEAS_ROAMING = 0
}

/**
 * サービス種別 の Union 型
 * @export
 * @typedef ServiceCategory
 */
export type ServiceCategory =
  typeof ServiceCategoryEnum[keyof typeof ServiceCategoryEnum];

/**
 * サービス種別 のラベルマップ
 * @export
 */
export const ServiceCategoryLabels = {
    /**
     * 数値キー: ServiceCategoryEnum.OVERSEAS_ROAMING
     * 名前キー:  OVERSEAS_ROAMING
     */
    [ServiceCategoryEnum.OVERSEAS_ROAMING]: '海外連携サービス',
    OVERSEAS_ROAMING:                             '海外連携サービス',
} as const;

/**
 * サービス種別 のラベル Union 型
 * @export
 * @typedef ServiceCategoryLabel
 */
export type ServiceCategoryLabel =
  typeof ServiceCategoryLabels[keyof typeof ServiceCategoryLabels];

/**
 * サービス種別 のラベル取得関数
 * @export
 * @param { ServiceCategory } value - 列挙体の値
 * @returns { ServiceCategoryLabel } ラベル文字列
 */
export function getServiceCategoryLabel(
  value: ServiceCategory
): ServiceCategoryLabel {
  return ServiceCategoryLabels[value];
}

/**
 * サービス種別 のラベル配列を取得する関数
 * @export
 * @param { ServiceCategory[] } values - 列挙体の値配列
 * @returns { ServiceCategoryLabel[] } ラベル文字列配列
 */
export function getServiceCategoryLabels(values: ServiceCategory[]): ServiceCategoryLabel[] {
  return values.map((value) => getServiceCategoryLabel(value));
}

/**
 * サービス種別 のラベル配列
 * @export
 */
export const ServiceCategoryLabelList = [
  '海外連携サービス',
] as const;

